import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import BaseDialog from '../BaseDialog';

const CreateRoomConfirmDialog = ({
  isVisible,
  onClose,
  onConfirm,
  ownerCreateLimit,
  loading = false,
}) => {
  const beforeLimit = Number(ownerCreateLimit ?? 0);
  const afterLimit = Math.max(beforeLimit - 1, 0);

  return (
    <BaseDialog isVisible={isVisible} onClose={onClose} maxWidth="min(92vw, 420px)" clickOutsideToClose={!loading}>
      <Box sx={{ width: 360, maxWidth: '100%', p: 1 }}>
        <Stack spacing={1.5}>
          <Typography variant="body1" sx={{ fontWeight: 700 }}>
            この内容でルームを作成しますか？
          </Typography>
          <Box sx={{ p: 1.25, borderRadius: 2, bgcolor: '#f8fafc', border: '1px solid #cbd5e1' }}>
            <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 900 }}>
              作成後の所持アイテム
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 900 }}>
              ルーム作成可能数：{beforeLimit.toLocaleString()}回 → {afterLimit.toLocaleString()}回
            </Typography>
          </Box>
          <Stack direction="row" spacing={1} justifyContent="flex-end">
            <Button variant="outlined" onClick={onClose} disabled={loading}>
              いいえ
            </Button>
            <Button variant="contained" onClick={onConfirm} disabled={loading}>
              はい
            </Button>
          </Stack>
        </Stack>
      </Box>
    </BaseDialog>
  );
};

export default CreateRoomConfirmDialog;
